import { render, staticRenderFns } from "./pos-list.vue?vue&type=template&id=4b7788a6&"
import script from "./pos-list.vue?vue&type=script&lang=js&"
export * from "./pos-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports